import React, { Component } from 'react'
import { Message } from 'semantic-ui-react'

class WarningMessageWithCloseOption extends Component {
  state = { visible: true }
  constructor(props) {
    super(props);      
  } 

  handleDismiss = () => {
    this.setState({ visible: false });
    this.props.eventCloseMessage();    
  }

  render()
  {     
    const message = this.props.message;
    if (this.state.visible) {
      return (
                <Message  
                  className="compact w-650 d-flex ml-auto mr-24 close icon" 
                  negative 
                  content-align="right" 
                  onDismiss={this.handleDismiss} 
                  content={message}               
                 />
             );
      }
      else
        return null;
    }
}

export default WarningMessageWithCloseOption;